var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueFlame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 4c0 .75-.25 1.75-1.45 2.15.35-.85.4-1.7.15-2.5-.35-1.05-1.5-1.85-2.3-2.3-.2-.15-.55.05-.5.35 0 .55-.15 1.35-1 2.2C2.05 5 1.5 6.15 1.5 7.25c0 1.45 1 3.25 3 3.25-2-2-.5-3.75-.5-3.75.4 2.95 2.5 3.75 3.5 3.75.85 0 2.5-.6 2.5-3.2 0-1.55-.65-2.75-1.2-3.45-.15-.25-.5-.1-.55.15z",
    fill: "#135FC4"
  })));
}
export default SvgBlueFlame;